module.exports = __webpack_public_path__ + "static/Group-3-f26621db64482d3db1f67fd08dadb15a.png";